export const environment = {
  production: false,
  //bffUrl: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts',
  bffKbaId: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/kba',
  bffKba: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/kba',
  bffCustomersBlackList: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/customers/blacklist',
  bffAccountsCounter: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/accounts-counter',
  bffCustomers: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/customers',
  bffCustomersInfo: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/customers/info',
  bffCustomersCompanies: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/customers/companies/',
  bffCustomersCompaniesLegalRepresentative: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/customers/companies',
  bffCreate: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/create',
  bffCorrelationsStatus: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/correlations',
  bffParameters: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/parameters',
  bffLocationDepartments: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/location/departments',
  bffLocationDepartmentsProvinces: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/location/departments',
  bffLocationDepartmentsProvincesDistricts: 'https://apiqa.digital.interbank.pe/business-accounts/v1/bff-business-accounts/location/departments',

  //bffSecurityUrl: 'https://apiqa.digital.interbank.pe/bff-security/v1/bff-security',
  bffOauth: 'https://apiqa.digital.interbank.pe/bff-security/v1/bff-security/oauth',


  cdn: 'https://web-qa.digital.interbank.pe/bindings/js/business-account@0.0.1',
  iframeUrl: 'assets/html/newrelic-qa.html',
  //bffUrlOtp: 'https://apiqa.digital.interbank.pe',

//bffAuthentication: 'https://apiqa.digital.interbank.pe/bff-authentication',
  bffOtpSignature: 'https://apiqa.digital.interbank.pe/bff-authentication/v1/bff-authentication/otpSignature', 
  bffAuthFactorsInfo: 'https://apiqa.digital.interbank.pe/bff-authentication/v1/bff-authentication/auth-factors-info',
  bffIdentityAuthAdapterStatus: 'https://apiqa.digital.interbank.pe/bff-authentication/v1/bff-authentication/identity-auth-adapter/status',
  bffOtpValidate: 'https://apiqa.digital.interbank.pe/bff-authentication/v1/bff-authentication/otpValidate',

  applicationId: 'toyujifrupr83aqidaCl',
  apiUrl: 'https://apiqa.digital.interbank.pe'
};
